<template>
  <div class="ai-design-search">
    <div class="search-box">
      <el-input
        v-model="keyword"
        type="textarea"
        class="textarea"
        :maxlength="max"
        :autosize="{ minRows: 1, maxRows: 10}"
        placeholder="做一个标题是“上云精选”，内容是“云服务器、云数据库特惠抢购”的banner"
        :disabled="loading"
        @change="handleChange"
      ></el-input>
      <i v-show="keyword" :class="{disabled: loading}" class="el-icon-error" @click="handleChange('')"></i>
      <zhitu-icon icon="huihua4" class="icon-size24 prefix-icon" :color="loading ? '#999999': '#CCCED2'"></zhitu-icon>
      <slot></slot>
    </div>
    <div class="search-btn" :disabled="loading" @click="handleGen">AI生成
      <div class="el-loading-spinner" v-show="loading">
        <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ai-design-search-box',
  props: {
    value: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      loading: false
    },
    max: {
      type: Number,
      default: 200
    }
  },
  created () {
    this.keyword = this.value
    this.$emit('input', this.value)
  },
  data () {
    return {
      keyword: ''
    }
  },
  watch: {
    value (val) {
      this.keyword = val
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('input', val)
    },
    handleGen () {
      this.$emit('on-click', this.keyword)
    }
  }
}
</script>
<style lang="scss" scoped>
.ai-design-search {
  display: inline-flex;
  flex-grow: 16px;
  width: 100%;
  text-align: center;
  .search-box {
    flex: 1;
    position: relative;
    width: 0;
    .textarea {
      :deep(.el-textarea__inner) {
        padding: 12px 44px 12px 58px;
        border: 1px solid #E3E5E8;
        border-radius: 24px;
        resize: none;
        background: #F5F6F7;
        color: #323337;
        &[disabled=disabled] {
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }
    .prefix-icon {
      position: absolute;
      top: 14px;
      left: 20px;
      // color: #CCCED2;
    }
    .el-icon-error {
      position: absolute;
      top: 14px;
      right: 16px;
      font-size: 18px;
      color: #8F96A3;
      cursor: pointer;
      &.disabled {
        cursor: no-drop;
      }
    }
  }
  .search-btn {
    position: relative;
    margin-left: 16px;
    width: 120px;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    font-weight: 600;
    border-radius: 260px;
    background: linear-gradient(112deg, rgba(28,217,179,0.80) 0%, rgba(15,66,232,0.80) 99%);
    backdrop-filter: blur(6px);
    color: #FFFFFF;
    cursor: pointer;
    .el-loading-spinner {
      display: inline-block;
      position: relative;
      width: auto;
      height: auto;
      vertical-align: -3px;
      top: 0px;
      margin-top: 0;
      .circular {
        width: 18px;
        height: 18px;
      }
      .path {
        stroke: #ffffff;
      }
    }
    &[disabled]::after {
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 260px;
      background: rgba(0, 0, 0, 0.2);
      cursor: no-drop;
    }
  }

}
</style>
